import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7eac1e9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar" }
const _hoisted_2 = { class: "sidebar_container" }
const _hoisted_3 = {
  key: 0,
  class: "sidebar_content sidebar_content--contact"
}
const _hoisted_4 = { class: "sidebar__title" }
const _hoisted_5 = { class: "sidebar__introduction" }
const _hoisted_6 = { class: "sidebar__text" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { class: "sidebar__contact_item" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "sidebar__subtitle" }
const _hoisted_11 = {
  key: 1,
  class: "sidebar_content sidebar_content--search"
}
const _hoisted_12 = { class: "sidebar__title" }
const _hoisted_13 = { class: "sidebar__introduction" }
const _hoisted_14 = {
  key: 2,
  class: "sidebar_content sidebar_content--tickets"
}
const _hoisted_15 = { class: "sidebar__title" }
const _hoisted_16 = { class: "sidebar__introduction" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Textures = _resolveComponent("Textures")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_FAQ = _resolveComponent("FAQ")!
  const _component_Search = _resolveComponent("Search")!
  const _component_PriceTable = _resolveComponent("PriceTable")!
  const _directive_sanitize = _resolveDirective("sanitize")!

  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createVNode(_component_Textures, {
      class: "backgroundwrapper__texture",
      type: "fine-01",
      color: "blackish"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: "#",
        class: "sidebar__closebutton",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args)))
      }, [
        _createVNode(_component_Icon, { type: "close" })
      ]),
      (_ctx.view === 'contact')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.content.contact.title), 1),
            _withDirectives(_createElementVNode("div", _hoisted_5, null, 512), [
              [_directive_sanitize, _ctx.content.contact.text]
            ]),
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("div", null, null, 512), [
                [_directive_sanitize, _ctx.content.contact.address]
              ]),
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_Icon, {
                  type: "contact-phone",
                  class: "sidebar__contact_icon"
                }),
                _createElementVNode("a", {
                  href: `tel:${_ctx.content.contact.phonelink}`,
                  class: "sidebar__link"
                }, _toDisplayString(_ctx.content.contact.phone), 9, _hoisted_9)
              ])
            ]),
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.content.contact.contact_per_subject_title), 1),
            _createVNode(_component_FAQ, { items: _ctx.contactPerSubject }, null, 8, ["items"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.view === 'search')
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.content.search.title), 1),
            _withDirectives(_createElementVNode("div", _hoisted_13, null, 512), [
              [_directive_sanitize, _ctx.content.search.text]
            ]),
            _createVNode(_component_Search, { toggleSidebar: _ctx.toggleSidebar }, null, 8, ["toggleSidebar"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.view === 'tickets')
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("h1", _hoisted_15, _toDisplayString(_ctx.content.tickets.title), 1),
            _withDirectives(_createElementVNode("div", _hoisted_16, null, 512), [
              [_directive_sanitize, _ctx.content.tickets.text]
            ]),
            _createVNode(_component_PriceTable, {
              sidebarMode: true,
              prices: _ctx.prices
            }, null, 8, ["prices"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}